import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-lg">
        {/* Cancel icon */}
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-amber-600" />
        </div>

        <h1 className="text-3xl font-serif font-light text-sage-700 mb-2">
          Paiement annulé
        </h1>
        
        <p className="text-sage-600 mb-8">
          Votre paiement n'a pas été finalisé. Aucun montant n'a été débité.
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate('/landing')}
            className="w-full h-14 bg-sage-500 hover:bg-sage-600 text-white rounded-xl"
          >
            <RefreshCw className="w-5 h-5 mr-2" />
            Réessayer
          </Button>
          
          <Button
            onClick={() => navigate('/landing')}
            variant="outline"
            className="w-full h-12 border-sage-300 text-sage-600 rounded-xl"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </div>

        <p className="text-xs text-sage-500 mt-6">
          Une question ? Contactez-nous pour toute assistance.
        </p>
      </div>
    </div>
  );
};

export default PaymentCancel;
